// Gassi-Kapazität: Regeln, die book-with-credit prüft und der Buchungskalender anzeigt.
//
// Q-D1 (27.10.2026): Vorher standen diese Werte zweimal im Code, einmal in
// book-with-credit/index.ts und einmal im Frontend (useSlotCapacity, timeSlots,
// RegelterminBookingFlow) mit dem Kommentar „Spiegel zu …“. Jetzt ist das hier die
// einzige Quelle: book-with-credit importiert sie, das Frontend importiert dieselbe Datei
// (Vite kann relative Pfade außerhalb von src/ bündeln, wie bei gassi-buchungsfrist.ts).
//
// Deshalb: reine Werte und Funktionen, keine Deno-APIs, keine URL-Importe.

/** Punkte-Budget v2: Punkte je Hunde-Level. */
export const DOG_LEVEL_POINTS: Record<number, number> = {
  1: 0.5, // Easy
  2: 1.0, // Standard (Default)
  3: 2.0, // Anspruchsvoll
};

/** Punkte eines Hundes; ohne Level gilt Level 2, unbekannte Level zählen 1 Punkt. */
export function getDogPoints(dogLevel: number | null | undefined): number {
  return DOG_LEVEL_POINTS[dogLevel ?? 2] ?? 1.0;
}

/** Slot-Klasse eines time_slot-Werts („Vormittags“, „08:00 - 12:00 Uhr“, „Samstag“ …). */
export function classifyTimeSlot(ts: string): "morning" | "afternoon" | "saturday" {
  const s = (ts || "").toLowerCase().trim();
  if (s === "saturday" || s.startsWith("samstag") || s.includes("10:30")) return "saturday";
  if (s === "morning" || s === "vormittags" || s.includes("vormittag")
      || s.includes("08:00") || s.includes("09:") || s.includes("10:") || s.includes("11:")) return "morning";
  return "afternoon";
}

// Wandertage: an diesen Tagen ist nur Ganztag (Vormittag + Nachmittag) buchbar.
// Ausnahme WANDERTAG_VM_ONLY_ALLOWED_DATES: zusätzlich Vormittag-only (Nachmittag-only nie).
// Kapazitätsdeckel 24.06.2026: max. 16 Vormittags-Buchungen (10 Ganztag + 6 VM-only).
export const WANDERTAG_DATES: readonly string[] = ["2026-04-24", "2026-06-05", "2026-06-24", "2026-08-28"];
export const WANDERTAG_VM_ONLY_ALLOWED_DATES: readonly string[] = ["2026-06-24"];
export const WANDERTAG_VM_CAP: Readonly<Record<string, number>> = { "2026-06-24": 16 };
